import { isDefined } from "@ls/js-utils";

export default class HoldingAttributeDefinition {
  static getDefault = () =>
    new HoldingAttributeDefinition({
      attribute: "finalWeight",
    });

  #attribute;

  constructor(props = {}) {
    const { attribute } = props;
    this.#attribute = attribute;
  }

  copy = () => ({
    attribute: this.#attribute,
  });

  get attribute() {
    return this.#attribute;
  }

 get key() {
 return `${this.#attribute}`;
}


  get complete() {
    return isDefined(this.#attribute);
  }

  setAttribute = (value) =>
    new HoldingAttributeDefinition({
      attribute: value,
    });
}
